module.exports = __webpack_public_path__ + "static/media/savio22.59693499.jpg";